

import { install } from "vant";



export default {
    ru: {
        '运费：': "Оплата доставки：",
        "地址":" адрес ",
        "名称":" имя ",
        "西线":'Западная линия ',
        "东线":'Восточная линия ',
        "库存为:":"На складе:",
        "库存不足":"Нехватка запасов ",
        "提示":" Подсказка ",
        "支付失败":"Неудача платежа",
        "支付成功":"Платёж успешно ",
        "加载中...":"В номере... ",
        "请输入护照号":"Введите номер паспорта",
        "请输入电话号":"Пожалуйста, введите номер телефона",
        "积分规则":"Правило интегрирования",
        "确定":"Точно",
        "请添加收货地址！":"Добавить адрес получателя! ",
        "取消":" Отмена ",
        "请输入密码":"Пожалуйста, введите пароль",
        "以字母开头，不能有特殊符号，长度限制在4-16位":"В начале буквы не может быть специальных символов, длина ограничена 4 - 16 битами ",
        "由字母和数字组成，区分大小写，长度限制为6-12":" Состоит из букв и цифр, различающих размер и длину до 6 - 12",
        "请输入用户名称":" Введите имя пользователя",
        "复制成功":" Успех репликации ",
        "复制失败":" Неудача репликации",
        "客服邮箱":" Почтовый ящик ",
        "护照号":"Номер паспорта",
        "请输入正确的护照号":"Пожалуйста, введите правильный номер паспорта",
        "物流信息:":"Логистическая информация:",
        "物流信息：已拣货待发货":"Логистическая информация: товары, которые были отобраны для отправки",
        "去看看":"Иди, посмотри",
        "可以去看看有哪些想买的":"Можно посмотреть, что вы хотите купить",
        "您还没有相关的订单":"У вас нет соответствующего заказа",
        "请添加或选择收货地址":" Добавить или выбрать адрес получателя ",
        "支付方式：":" Форма платежа: ",
        "Qiwi":'Qiwi',
        "webmoney":"Электронный банк",
        "信用卡":'Кредитная карта',
        "删除成功!":'Удалено успешно!',
        "修改成功":'Изменение завершено !',
        "是否要删除此收货地址？":'Удалить этот адрес получателя? ',
        "新增地址成功":'Новый адрес успешно добавлен !',
        "是否设置为默认地址":'Установить адрес по умолчанию !',
        "选择自提点":'Выберите точку ',
        "自提点":' Пункт самовывоз ',
        "请输入详细地址":"Введите адрес ",
        "详细地址":'Подробный адрес ',
        "选择省市区":' Выбрать город провинции ',
        "地区选择":"Выбор области ",
        "请填写电话":' Заполните, пожалуйста, телефон. ',
        "请填写收货人姓名":'Заполните, пожалуйста, имя получателя. ',
        "收货人姓名":'Имя получателя',					
        "保存失败":"Ошибка сохранения !",
        "保存成功":"Сохранить успешно ",
        "自提点地址":'Адрес с независимой точкой ',
        "我的地址":'Мой адрес',
        "添加收货地址":'Добавить адрес',
        "可用积分为":"Доступное интегрирование ",
        "请确认电话号码是否正确，方便卖家与您联系":" Убедитесь, что номер телефона верен, и удобно ли продавцу связаться с вами, позвоните по телефону: ",
        "请输入正确的电话号码":"Введите правильный номер телефона ",
        "电话号码":"Телефон",
        "因物流运费的不同，将订单拆分成两个订单":"Из-за разницы в логистических перевозках заказ делится на два заказа.",
        "待处理订单":'Готовый заказ',
        "临时订单":"Предварительные заказы",
        "个人中心":"Персональный центр",
        "使用积分":"Эксплуатационный интеграл ",
        "积分详情":"Детали очков",
        "店铺信息":"Информация о магазине",
        "该积分可用于抵扣部分下单商品的价钱：1积分=1₽":"Из баллов можно вычесть стоимость некоторых заказанных товаров: 1 балл = 1₽",
        "当前账号积分":"Баллы текущего счета",
        "该商品库存不足，无法下单":"Товара недостаточно для размещения заказа.",
        "库存不足，无法下单":"Недостаточно запасов для размещения заказа",
        "你购买的":"Ты купил",
        "货物需要运输费用，请与服务人员联系":"Товар нуждается в транспортных расходах, пожалуйста, свяжитесь с обслуживающим персоналом",
        "去支付":"Oплатить",
        "店铺名称":"Название магазина ",
        "更改密码":"Изменить пароль ",
        "完成收货":"Завершать получение ",
        "待付款":"Подлежать оплате ",
       "此商品无具体的商品选择,可直接加入购物车": "Тип логистики этот товар не имеет конкретного выбора товаров, можно прямо присоединиться к магазинной машине ",
        "物流类型:": "Тип логистики :",
        "物流号:": " Логистика :",
        订单收货:"Получение заказа ",
        取消订单:"Аннулировать заказ ",
        language: 'ru',
        暂无数据: "Пока нет данных ",
        "待收货": "Ожидающий получения ",
        订单管理: "Управление заказами ",
        用户名称: "Имя пользователя",
        "3~16位英文或数字": "3 ~ 16 битов английский или цифра",
        "6~18位英文或数字": '6 ~ 18 битов английский или цифра',
        "请输入符合规则的用户名": "Введите имя пользователя ",
        "请输入符合规则的密码": "Введите пароль, соответствующий правилам ",
        "3天内发货": "Отгрузка в течение 3 дней ",
        订单详情: "Подробности заказа ",
        "合计金额": " Общая сумма:₽",
        "下单时间:": " Следующее время:",
        "订单状态:": "Состояние заказа:",
        "订单编号:": "Номер заказа:",
        收货地址: "Адрес получения",
        确认密码: "Подтвердить пароль",
        没有更多了: "Больше нет",
        请输入商品名称: "Введите наименование товара ",
        取消: "Отмена",
        请选择商品规格: "Выберите стандарт",
        添加成功: " Добавление успешно ",
        添加失败: "Ошибка добавления",
        选择: "Выбор",
        请选择: "Выберите ",
        颜色分类: "Классификация цветов",
        已选: "Избранный ",
        参数: "Параметры ",
        规格: "Стандарт ",
        产品参数: "Параметр продукции",
        请选择规格: 'Выберите размер',
        // 请输入搜索关键词: 'Введите ключевые слова поиска',
        返回: 'Возвращение ',
        删除: 'Удалить ',
        商品规格: "Стандарт товара",
        请选择商品: "Выберите товар ",
        订单创建完成: 'Создание заказа завершено ',
        订单创建失败: 'Ошибка создания заказа ',
        请选择要购买的商品: 'Выберите товар ',
        确认订单: " Подтверждать заказ",
        现金: "Денежная наличность ",
        赊账: "В кредит",
        保存: "Сохранить ",
        请输入您的昵称: "Введите ваш ник",
        登录成功: "Регистрация прошла успешно ",
        用户名或密码错误: "Ошибка по имени или паролю",
        已退出: "Выход",
        复制成功: "Копировать успешно ",
        复制失败: "Ошибка копирования ",
        请稍后重试: "Попробуйте позже",
        确认: " Подтверждение",
        该账号已注册: "Номер счета зарегистрирован ",
        两次输入密码不同: "Дважды введённый пароль отличается",
        请重新输: "Пожалуйста, снова проиграйте",
        商品名称: "Наименование товара",
        登陆后可同步购物车商品: "Товары для покупки автомобилей после посадки",
        "订单创建已完成": " Создание заказа завершено ",
        返回首页: "Вернуться на главную страницу ",
        订单已提交: "Заказ представлен",
        请重新登陆: " Прошу вас вновь высадиться ",
        高级商城: "Премиум Молл",
        用户名: "Логин",
        请填写用户名: "Введите логин",
        请填写密码: "Введите пароль",
        密码: "Пароль",
        请再一次填写密码: "Пожалуйста, заполните пароль еще раз.",
        两次密码不一致: "Пароли не  совпадают ",
        立即登录: "Войти сейчас",
        立即注册: "Зарегистрироваться",
        "还没有账号": "Еще нет аккаунта",
        "已经有账号": "Уже есть аккаунт",
        注册: "Регистрация",
        点击注册: "Зарегистрироваться",
        点击登录: "Войти",
        登录: "Войти",
        退出登录: "Выйти из аккаунта",
        "确实要退出吗？": "Вы уверены, что хотите выйти？",
        姓名: "Имя",
        收货人姓名: "Имя получателя",
        电话: "Номер  телефона",
        收货人电话号码: "Номер телефона грузополучателя",
        点击选择收货人所在国家: "Нажмите, чтобы выбрать страну получателя",
        点击设置收件人信息: "Нажмите, чтобы установить информацию о получателе",
        地址: "Адрес",
        详细地址: "Подробный адрес",
        "省市区、街道门牌、楼层房间号等": "Район.Город.Улица.Подъезд.Этаж.Квартира",
        默认地址: "Адрес по умолчанию",
        确认修改: "Подтвердите изменения",
        确认新增: "Подтвердите добавление",
        返回上一页: "Вернуться на предыдущую страницу",
        "还没有地址，快去新建一个吧": "Нет адреса, создайть новый.",
        新建地址: "Создать адрес",
        编辑地址: "Редактировать адрес",
        订单号: "Номер заказа",
        查看订单: "Посмотреть заказ",
        再去逛逛: "Продолжить просмотр",
        支付方式: "Способ оплаты",
        转账: "Перевод",
        商品金额: "Цена товара",
        优惠: "Скидка",
        运费: "Оплата доставки",
        合计: "Итого",
        提交订单: "Оформить заказ",
        注册成功: "Успешная регистрация",
        // 再去逛逛: "Снова за покупками",
        订单提交成功: "Заказ успешно отправлен",
        合计: "Итого",
        全选: "Выбрать все",
        提交订单: "Оформить заказ",
        购物车空空滴: "Ваша корзина пуста",
        添加到购物车: "添加到购物车",
        去逛逛: "Делать покупки",
        已售: "Уже продано",
        库存: "库存",
        数量: "数量",
        发送: "发送",
        请输入留言: "请输入留言",
        件: " Штук",
        "已售_": "В наличии ",
        " 已售 [100] 件": "Продано 100 штук",
        我的订单: "Мои заказы",
        查看全部订单: "Все заказы",
        暂无订单: "Нет заказов",
        地址管理: "Адрес администратора",
        客服电话: "Телефон службы поддержки",
        人工客服时间: "Время обслуживания клиентов",
        "全部": "Все заказы",
        待支付: "Ожидается платёж ",
        待发货: "Ожидается отправка ",
        已发货: "Заказ отправлен ",
        已完成: "Получено",
        已取消: "Был отменен",
        分类: " Категория",
        批发价: "Оптовая цена",

        猜你喜欢: "Полагаю,вам понравиться",
        "注册/登录": "Войти /Регистрация",
        设置: "Настройки",
        头像: "Аватарка",
        昵称: "Ник",
        订单编号: "Номер отслеживания",
        购物车: "Корзина",
        加入购物车: "Добавить в корзину",
        下单时间: "Дата заказа",
        商品金额: "Цена товара",
        首页: "Главная",
        在购物车等亲: "Перейти к корзине",
        商品详情: " Детали продукта",
        我的: "Мой профиль",
        新增地址: "新增地址",
        客服: "Сервис клиента",
        "新增地址": "Добавить адрес",
        "默认": "По умолнинию",
        "库存": "Складские запасы",
        "数量": "Количество",
        "发送": "Отправить",
        "请输入留言": "Пожалуйста, введите сообщение",
        "添加到购物车": "Добавить в корзину",
        "您的订单已成功提交，感谢您对我们的信任，我们会尽快与您联系确认订单!": "Ваш заказ был успешно отправлен, спасибо за ваше доверие к нам, мы свяжемся с вами как можно скорее, чтобы подтвердить заказ!",
        "我": "я",
        "你好，欢迎光临，如果长时间没有回复，请拨打电话": "Здравствуйте, если не хотите долго ждать ответ оператора, то вы можете позвонить по этому номеру:"
    },
    zh_cn: {
        '运费：': "运费：",
        "名称":"名称",
        "地址":"地址",
        "东线":"东线",
        "西线":"西线",
        "库存为:":"库存为:",
        "提示":" 提示",
        "库存不足":"库存不足",
        "支付失败":"支付失败",
        "支付成功":"支付成功",
        "加载中...":"加载中...",
        "请输入护照号":"请输入护照号",
        "请输入电话号":"请输入电话号",
        "积分规则":"积分规则",
        "请添加收货地址！":"请添加收货地址！",
        "确定":"确定",
        "取消":"取消",
        "请填写收货人姓名":'请填写收货人姓名 ',
        "请输入密码":"请输入密码",
        "以字母开头，不能有特殊符号，长度限制在4-16位":"以字母开头，不能有特殊符号，长度限制在4-16位",
        "由字母和数字组成，区分大小写，长度限制为6-12":" 由字母和数字组成，区分大小写，长度限制为6-12",
        "请输入用户名称":" 请输入用户名称",
        "复制成功":" 复制成功 ",
        "复制失败":" 复制失败",
        "客服邮箱":"客服邮箱",
        "护照号":"护照号",
        "请输入正确的护照号":"请输入正确的护照号",
        "物流信息:":"物流信息:",
        "物流信息：已拣货待发货":"物流信息：已拣货待发货",
        "去看看":"去看看",
        "可以去看看有哪些想买的":"可以去看看有哪些想买的",
        "您还没有相关的订单":"您还没有相关的订单",
        "请添加或选择收货地址":"请添加或选择收货地址",
        "支付方式：":"支付方式：",
        "Qiwi":'Qiwi',
        "webmoney":"webmoney",
        "信用卡":'信用卡',
        "删除成功!":'删除成功!',
        "是否要删除此收货地址？":'是否要删除此收货地址？',
        "修改成功":'修改成功',
        "新增地址成功":'新增地址成功',
        "是否设置为默认地址":'是否设置为默认地址',
        "选择自提点":'选择自提点',
        "自提点":'自提点',
        "请输入详细地址":"请输入详细地址",
        "详细地址":'详细地址',
        "选择省市区":'选择省市区',
        "地区选择":"地区选择",
        "请填写电话":'请填写电话',
        "收货人姓名":'收货人姓名',
        "保存失败":"保存失败 !",
        "保存成功":"保存成功! ",
        "自提点地址":'自提点地址 ',
        "我的地址":'我的地址',
        "添加收货地址":'添加收货地址',
        "可用积分为":"可用积分为",
        "请确认电话号码是否正确，方便卖家与您联系":" 请确认电话号码是否正确，方便卖家与您联系,电话：",
        "请输入正确的电话号码":"请输入正确的电话号码",
        "电话号码":"电话号码",
        "因物流运费的不同，将订单拆分成两个订单":"因物流运费的不同，将订单拆分成两个订单",
        "待处理订单":'待处理订单',
        "临时订单":"临时订单",
        "个人中心":"个人中心",
        "使用积分":"使用积分",
        "积分详情":"积分详情",
        "店铺信息":"店铺信息",
        "该积分可用于抵扣部分下单商品的价钱：1积分=1₽":"该积分可用于抵扣部分下单商品的价钱：1积分=1₽",
        "当前账号积分":"当前账号积分",
        "该商品库存不足，无法下单":"该商品库存不足，无法下单",
        "库存不足，无法下单":"库存不足，无法下单",
        "你购买的":"你购买的",
        "你购买的商品库存不足，无法下单":"你购买的商品库存不足，无法下单",
        "货物需要运输费用，请与服务人员联系":"货物需要运输费用，请与服务人员联系",
        "去支付":"去支付",
        "店铺名称":"店铺名称",
        "更改密码":"更改密码",
        "完成收货":"完成收货",
        "待付款":"待付款",
        "此商品无具体的商品选择,可直接加入购物车":"此商品无具体的商品选择,可直接加入购物车",
        "物流类型:": " 物流类型:",
        "物流号:": " 物流号:",
        订单收货:"订单收货",
        取消订单:"取消订单",
        language: 'cn',
        暂无数据: "暂无数据",
        "待收货": "待收货",
        订单管理: "订单管理",
        商品名称: "商品名称",
        "3~16位英文或数字": "3~16位英文或数字",
        "6~18位英文或数字": "6~18位英文或数字",
        请输入符合规则的用户名: "请输入符合规则的用户名",
        请输入符合规则的密码: "请输入符合规则的密码",
        "3天内发货": "3天内发货 ",
        订单详情: "订单详情 ",
        合计金额: " 合计金额:₽",
        "下单时间:": " 下单时间:",
        "订单状态:": "订单状态:",
        "订单编号:": "订单编号:",
        收货地址: "收货地址",
        确认密码: "确认密码",
        用户名称: "用户名称",
        用户名: "用户名",
        分类: "分类",
        没有更多了: "没有更多了",
        请输入商品名称: "请输入商品名称",
        取消: "取消",
        请选择商品规格: "请选择商品规格",
        添加成功: "  添加成功 ",
        添加失败: "添加失败",
        选择: "选择",
        请选择: "请选择",
        颜色分类: "颜色分类",
        已选: "已选",
        参数: "参数",
        规格: "规格",
        产品参数: "产品参数",
        请选择规格: '请选择规格',
        返回: '返回',
        删除: '删除',
        商品规格: "商品规格",
        请选择商品: "请选择商品 ",
        订单创建完成: '订单创建完成 ',
        订单创建失败: '订单创建失败 ',
        请选择要购买的商品: '请选择要购买的商品',
        确认订单: "确认订单",
        现金: "现金",
        赊账: "赊账",
        保存: "保存",
        请输入您的昵称: "请输入您的昵称",
        登录成功: "登录成功 ",
        用户名或密码错误: "用户名或密码错误",
        已退出: "已退出",
        复制成功: "复制成功 ",
        复制失败: "复制失败 ",
        请稍后重试: "请稍后重试",
        确认: "确认",
        该账号已注册: "该账号已注册",
        两次输入密码不同: "两次输入密码不同",
        请重新输: "请重新输",
        批发价: "批发价",
        登陆后可同步购物车商品: '登陆后可同步购物车商品',
        "订单创建已完成": "订单创建已完成",
        返回首页: "返回首页",
        订单已提交: "订单已提交",
        请重新登陆: "请重新登陆",


        高级商城: "高级商城",
        用户名: "用户名",
        请填写用户名: "请填写用户名",
        请填写密码: "请填写密码",
        密码: "密码",
        请再一次填写密码: "请再一次填写密码",
        两次密码不一致: "两次密码不一致",
        立即登录: "立即登录",
        立即注册: "立即注册",
        注册成功: "注册成功",
        再去逛逛: "再去逛逛",
        "还没有账号": "还没有账号",
        "已经有账号": "已经有账号",
        注册: "注册",
        点击注册: "点击注册",
        点击登录: "点击登录",
        登录: "登录",
        退出登录: "退出登录",
        "确实要退出吗？": "确实要退出吗？",
        姓名: "姓名",
        收货人姓名: "收货人姓名",
        电话: "电话",
        收货人电话号码: "收货人电话号码",
        点击选择收货人所在国家: "点击选择收货人所在国家",
        点击设置收件人信息: "点击设置收件人信息",
        地址: "地址",
        详细地址: "详细地址",
        "省市区、街道门牌、楼层房间号等": "Район.город.Улица.Подъезд.этаж.квартира",
        默认地址: "默认地址",
        确认修改: "确认修改",
        确认新增: "确认新增",
        返回上一页: "返回上一页",
        "还没有地址，快去新建一个吧": "还没有地址，快去新建一个吧",
        新建地址: "新建地址",
        编辑地址: "编辑地址",
        订单号: "订单号",
        查看订单: "查看订单",
        再去逛逛: "再去逛逛",
        支付方式: "支付方式",
        转账: "转账",
        商品金额: "商品金额",
        优惠: "优惠",
        运费: "运费",
        合计: "合计",
        提交订单: "提交订单",
        订单提交成功: "订单提交成功",
        全选: "全选",
        购物车空空滴: "购物车空空滴",
        添加到购物车: "添加到购物车",
        去逛逛: "去逛逛",
        已售: "已售",
        库存: "库存",
        数量: "数量",
        发送: "发送",
        请输入留言: "请输入留言",
        件: "件",
        "已售_": "已售 ",
        //" 已售 [100] 件": "Продано 100 штук",
        我的订单: "我的订单",
        查看全部订单: "查看全部订单",
        暂无订单: "暂无订单",
        地址管理: "地址管理",
        客服电话: "客服电话",
        人工客服时间: "人工客服时间",
        "全部": "全部",
        待支付: "待支付",
        待发货: "待发货",
        已发货: "已发货",
        已完成: "已完成",
        已取消: "已取消",
        猜你喜欢: "猜你喜欢",
        "注册/登录": "注册/登录",
        设置: "设置",
        头像: "头像",
        昵称: "昵称",
        订单编号: "订单编号",
        购物车: "购物车",
        加入购物车: "加入购物车",
        下单时间: "下单时间",
        商品金额: "商品金额",
        首页: "首页",
        在购物车等亲: "在购物车等亲",
        商品详情: "商品详情",

        我的: "我的",
        新增地址: "新增地址",
        客服: "客服",
        默认: "默认",
    },
    install: function() {

    }
}

/*

高级商城					Премиум Молл
    用户名					Логин
    请填写用户名					Введите логин
    请填写密码					Введите пароль
    密码					Пароль
    请再一次填写密码					Пожалуйста, заполните пароль еще раз.
    两次密码不一致					Пароли не  совпадают
    立即登录					Войти сейчас
    立即注册					Зарегистрироваться
    还没有账号？					Еще нет аккаунта？
    已经有账号？					Уже есть аккаунт？
    注册					Регистрация

    点击注册					Зарегистрироваться
    点击登录					Войти
    退出登录					Выйти из аккаунта
    确实要退出吗？					Вы уверены, что хотите выйти ？

    姓名					Имя
    收货人姓名					Имя получателя
    电话					Номер  телефона
    收货人电话号码					Номер телефона грузополучателя
    点击选择收货人所在国家					Нажмите, чтобы выбрать страну получателя
    点击设置收件人信息					Нажмите, чтобы установить информацию о получателе
    地址					Адрес
    详细地址					Подробный адрес
    省市区、街道门牌、楼层房间号等					Район.Город.Улица.Подъезд.этаж.квартира
    默认地址					Адрес по умолчанию
    确认修改					Подтвердите изменения
    确认新增					Подтвердите добавление
    返回上一页					Вернуться на предыдущую страницу
    还没有地址，快去新建一个吧					Нет адреса, создайть новый.
    新建地址					Создать адрес
    编辑地址					Редактировать адрес
    订单号：					Номер заказа
    查看订单					Посмотреть заказ
    再去逛逛					Продолжить просмотр
    支付方式					Способ оплаты
    转账					Перевод
    商品金额					Цена товара
    优惠					Скидка
    运费					Оплата доставки
    合计					Итого
    提交订单					Оформить заказ
    订单提交成功					Заказ успешно отправлен
    合计：					Итого
    全选					Выбрть все
    提交订单					оформить заказ
    购物车空空滴~					Ваша корзина пуста
    去逛逛					Делать покупки
    已售					Уже продано
    已售 [100] 件					Продано 100 штук
    我的订单					Мои заказы
    查看全部订单					Все заказы
    暂无订单					Нет заказов
    地址管理					Адресная администрация
    客服电话					Телефон службы поддержки
    人工客服时间：					ВВремя обслуживания клиентов
    全部					Все заказы
    待支付					Ожидается платёж
    待发货					Ожидается отправка
    已发货					Заказ отправлен
    已完成					Получено
    已取消					Был отменен
    猜你喜欢					Полагаю,вам понравиться
    注册/登录					Войти /Зегистрация
    设置					Настройки
    头像					Аватарка
    昵称					Ник
    订单编号					Номер отслеживания
    购物车					Корзина
    加入购物车					Добавить в корзину
    下单时间					Дата заказа
    商品金额					Цена товара
    首页					Первая страница
    在购物车等亲~					Перейти к корзине
    商品详情					 Детали продукта
*/